import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { memo, useCallback, useEffect } from 'react';
import { UniversalDialog } from 'console/dialogs/universal';
import { useAction, useAppSelector } from 'shared/hooks/redux/hooks';
import { SuccessMessage } from 'entities/support.request/ui/success';
import { SupportFormContent } from 'entities/support.request/ui/content';
import { closeRequestSupportForm } from 'shared/support.request/model';
import { useBooleanState } from 'shared/hooks/state/boolean';
export const FormSupport = memo(function FormSupport() {
    const { open, key, response } = useAppSelector((state) => state.request_support_form);
    const onRequestClose = useAction(closeRequestSupportForm);
    const [opened_success, closeSuccess, openSuccess] = useBooleanState(false);
    useEffect(() => {
        if (response != null) {
            openSuccess();
        }
    }, [response]);
    const onClose = useCallback(() => {
        onRequestClose();
        closeSuccess();
    }, []);
    return (_jsxs(_Fragment, { children: [_jsx(UniversalDialog, { open: open, onClose: onClose, maxWidth: "sm", title: "\u041E\u0431\u0440\u0430\u0442\u0438\u0442\u044C\u0441\u044F \u0432 \u0442\u0435\u0445\u043F\u043E\u0434\u0434\u0435\u0440\u0436\u043A\u0443", children: _jsx(SupportFormContent, {}) }, key), _jsx(SuccessMessage, { open: opened_success, message: response, onClose: onClose })] }));
});
